import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {PSLeakDeviceIndicationResponse, PSLeakDeviceIndicationsResponse} from "../models/response"
import dayjs, {Dayjs} from "dayjs"

export const psLeakDeviceIndicationApi = {
    getIndications(params?: GetIndications): Promise<CommonResponse<PSLeakDeviceIndicationsResponse>>
    {
        const paramsString = filterToString(params)
        return instance.get(`PSLeakDeviceIndication${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getIndication(params: GetSingleParamsType): Promise<CommonResponse<PSLeakDeviceIndicationResponse>>
    {
        const {id, controller} = params
        return instance.get(`PSLeakDeviceIndication/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getIndicationGraph(params: GetIndicationGraph): Promise<CommonResponse<PSLeakDeviceIndicationsResponse>>
    {
        const {controller, ...rest} = params
        if (rest?.dateFrom) rest.dateFrom = dayjs(rest.dateFrom, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss")
        if (rest?.dateTo) rest.dateTo = dayjs(rest.dateTo, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm:ss")

        return instance.post(`PSLeakDeviceIndication/graph`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteAll(params: DeleteDeviceIndications): Promise<CommonResponse<boolean>>
    {
        const {idDevice, controller, password} = params
        return instance.delete(`PSLeakDeviceIndication/${idDevice}?password=${password}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type GetIndications = {
    idCompany?: number
    idObjectGroup?: number
    idObject?: number
    idDevice?: number
} & GetParamsType

export type GetIndicationGraph = {
    idDevice: number
    name: Array<string>
    dateFrom?: string | null | undefined
    dateTo?: string | null | undefined
} & BaseRequestParams

export type DeleteDeviceIndications = {
    idDevice: number
    password: string
} & BaseRequestParams
